<template>
  <div>
    <b-card>
      <b-row class="justify-content-md-center">
        <b-col cols="8">
          <Map
            :dates="dates"
            :selected-domains="selectedDomains"
            :status="status"
          />
        </b-col>
      </b-row>
      <b-row class="justify-content-md-center">
        <b-col cols="8" class="text-center">
          <span class="switch switch-outline switch-primary">
            <label class="switcher">
              {{ `Status: ${switchBlockedStatus()}` }}
              <input type="checkbox" v-model="status" name="select" />
              <span></span>
            </label>
          </span>
        </b-col>
      </b-row>
    </b-card>

    <b-row>
      <b-col cols="12">
        <CountriesTable
          :dates="dates"
          :selected-domains="selectedDomains"
          :status="status"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CountriesTable from "../../../components/Analytics/Countries/CountriesTable";
import Map from "../../../components/Analytics/Countries/Map";
import domainsAndDateSelection from "@/core/mixins/domainsAndDateSelection.mixin";

export default {
  components: {
    Map,
    CountriesTable
  },
  mixins: [domainsAndDateSelection],
  data() {
    return {
      status: true,
      calendar: false
    };
  },
  methods: {
    switchBlockedStatus() {
      if (this.status) {
        return "Blocked";
      }

      return "Not blocked";
    }
  }
};
</script>

<style scoped>
.switcher {
  line-height: 30px;
}
.switcher span {
  margin-right: 10px !important;
}
</style>
